module.exports = __webpack_public_path__ + "ed964a48f37090e3ef2beb06ef6809fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/question.svg
// module id = 775
// module chunks = 0